<template>
  <v-text-field
    ref="textField"
    v-bind="$attrs"
    :value="value"
    @input="$emit('input', $event)"
    outlined
  />
</template>

<script>
import Inputmask from 'inputmask';

export default {
  name: 'TextField',
  props: {
    mask: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  computed: {
    inputRef() {
      return this.$refs.textField.$refs.input;
    },
  },
  mounted() {
    if (this.mask) this.initMask();
  },
  methods: {
    initMask() {
      const im = new Inputmask(this.mask, {
        showMaskOnHover: false,
        onincomplete: () => {
          this.$emit('input', '');
        },
      });

      im.mask(this.inputRef);
    },
  },
};
</script>
